import React, { useState } from "react"
import './Header.scss'
import { Button, Container, Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import Marquee from "react-fast-marquee";

function Header() {
    const [expanded, setExpanded] = useState(false);
    const handleCloseMenu = () => setExpanded(false);

    return (
        <header className="main-header">
            <h1 className="d-none">Международная олимпиада по русскому языку</h1>

            <div className="desktop-header-wrapper d-none d-lg-block">
                <Container>
                    <div className="main-header-container">
                        <Navbar.Brand as={Link} smooth to="/" className="logo-container" onClick={handleCloseMenu}>
                            <div className="main-logo"></div>
                        </Navbar.Brand>

                        <div className="menu-container">
                            <Nav className="menu-row justify-content-center">
                                <Nav.Item><Nav.Link as={Link} smooth to="/#about" onClick={handleCloseMenu}>Об олимпиаде</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link as={Link} smooth to="/#documents" onClick={handleCloseMenu}>Документы</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link as={Link} smooth to="/#dates" onClick={handleCloseMenu}>Сроки проведения</Nav.Link></Nav.Item>
                            </Nav>
                            <Nav className="menu-row justify-content-center">
                                <Nav.Item><Nav.Link as={Link} smooth to="/#materials" onClick={handleCloseMenu}>Материалы для подготовки</Nav.Link></Nav.Item>
                                <Nav.Item><Nav.Link as={Link} smooth to="/gallery" onClick={handleCloseMenu}>Выставка</Nav.Link></Nav.Item>
                            </Nav>
                        </div>

                        <div className="btn-container">
                            <Button className='btn-invite' as="a" variant="primary">
                                принять участие
                            </Button>
                        </div>
                    </div>
                </Container>
            </div>

            <Navbar
                expand="lg"
                expanded={expanded}
                onToggle={(isOpen) => setExpanded(isOpen)}
                className="mobile-header-navbar d-lg-none"
            >
                <Container className="position-relative">
                    <Navbar.Brand as={Link} smooth to="/" className="logo-container" onClick={handleCloseMenu}>
                        <div className="main-logo"></div>
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="mobile-navbar-nav" />

                    <Navbar.Collapse id="mobile-navbar-nav">
                        <Nav className="text-center mobile-menu-links">
                            <Nav.Link as={Link} smooth to="/#about" onClick={handleCloseMenu}>Об олимпиаде</Nav.Link>
                            <Nav.Link as={Link} smooth to="/#documents" onClick={handleCloseMenu}>Документы</Nav.Link>
                            <Nav.Link as={Link} smooth to="/#dates" onClick={handleCloseMenu}>Сроки проведения</Nav.Link>
                            <Nav.Link as={Link} smooth to="/#materials" onClick={handleCloseMenu}>Материалы для подготовки</Nav.Link>
                            <Nav.Link as={Link} smooth to="/gallery" onClick={handleCloseMenu}>Выставка</Nav.Link>
                        </Nav>
                        <div className="mobile-btn-wrapper d-flex justify-content-center">
                            <Button className='btn-invite' as="a" variant="primary">
                                принять участие
                            </Button>
                        </div>
                    </Navbar.Collapse>
                </Container>
            </Navbar>

            <Marquee className="ticker-container">
                <div className="ticker-string">
                    <div className="ticker-text">
                        {'225 лет со дня рождения В. И. Даля              225 лет со дня рождения В. И. Даля              225 лет со дня рождения В. И. Даля              225 лет со дня рождения В. И. Даля              '}
                    </div>
                </div>
            </Marquee>
        </header>
    );
}

export default Header;
